<template>
    <el-dialog
        class="info"
        :visible.sync="infoVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="800px"
        title="报名信息"
    >
        <div class="container">
            <el-table
                border
                :data="tableData"
                v-loading="loading"
                highlight-current-row
            >
                <el-table-column
                    label="姓名"
                    width="80"
                    property="staff_name"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="手机号"
                    property="staff_phone"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="报名时间"
                    property="create_time"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="是否签到"
                    width="80"
                    property="sign_in_cn"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="签到时间"
                    property="sign_in_time"
                    align="center"
                ></el-table-column>
                <el-table-column label="操作" align="center" v-if="tableItem.status!=20">
                    <template slot-scope="scope">
                        <div class="color-blue">
                            <el-button
                                type="text"
                                size="small"
                                class="color-blue"
                                @click="cancel(scope.row)"
                                >取消报名</el-button
                            >
                        </div>
                    </template></el-table-column
                >
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
        ></pagination>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="infoVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as api from "@/http/api.js";
import * as oaApi from "@/http/oaApi.js";
import { mapState } from "vuex";
import pagination from "@/comon/components/pagination";
export default {
    data() {
        return {
            loading: false,
            tableData: [],
            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },
        };
    },
    components: {
        pagination,
    },
    computed: {},
    props: {
        tableItem: Object,
        infoVisible: Boolean,
    },
    watch: {
        perPage: {
            handler(newValue) {
                this.perPage = newValue;
                this.eventsSignupList();
            },
            deep: true,
            immediate: false,
        },
        page: {
            handler(newValue) {
                this.page = newValue;
                this.eventsSignupList();
            },
            deep: true,
            immediate: false,
        },
        infoVisible: {
            handler(newValue) {
                if (newValue) {
                    this.eventsSignupList();
                }
            },
        },
    },
    methods: {
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:infoVisible", false);
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.eventsSignupList();
        },
        eventsSignupList() {
            this.loading = true;
            oaApi
                .eventsSignupList(
                    {
                        ...this.paginationData,
                        event_id: this.tableItem.id,
                    },
                    "get"
                )
                .then((res) => {
                    this.loading = false;
                    //console.log(res);
                    if (res.code == 200) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                    }
                });
        },
        cancel(row) {
            //console.log(row);
            oaApi.eventsSignupList({}, "delete", row.id).then((res) => {
                if (res.code == 200) {
                  this.$message.success("取消成功!");
                  this.$parent.activityList();
                  this.eventsSignupList();
                }else{
                  this.$message.error("取消失败!");
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.info {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
        min-height: 80px;
        .seccussImg {
            width: 80px;
            margin-top: 18px;
        }
        .seccussText {
            font-size: 18px;
            font-weight: bold;
            line-height: 2;
            margin-top: 18px;
        }
        .tableSchool,
        .tableHealth {
            .el-form-item--small.el-form-item {
                margin-bottom: 0;
            }
        }
    }
}
.edit_table_class {
    z-index: 2200;
}
</style>